import { render, staticRenderFns } from "./ImportCustomersForm.vue?vue&type=template&id=1ec0419a&scoped=true"
import script from "./ImportCustomersForm.vue?vue&type=script&lang=js"
export * from "./ImportCustomersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0419a",
  null
  
)

export default component.exports